module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/cd-f92cf749f4898b5342c6aace1c13d3c9.svg";